import getApiCall from "./getApiCall";

const cache = new Map();

export const prefetch = (endpoint, id = null) => {
  const promise = getApiCall(endpoint, id);
  cache.set(endpoint, promise);
  return promise;
};

export const prefetchCustom = (key, promise) => {
  cache.set(key, promise);
  return promise;
};

export const consume = (key) => {
  const promise = cache.get(key);
  if (promise) {
    cache.delete(key);
  }
  return promise || null;
};

export const clear = () => {
  cache.clear();
};
